import { Fragment, h } from 'preact';
import './file.scss';

export function FileSuggestion(props: any) {
    const rootServiceInstance = props?.msgData?.hostInstance?.rootService;
    const languageData = props?.hostInstance?.languagedata
    return (
        <div>
            {
                props?.msgData?.files?.map((file: any, inx: any) => (
                    <div
                        key={inx}
                        className="suggestion-item-card aa-each-suggestion ">
                        <div className="suggestion-header-faq aa-suggestion-header">
                            <div className="titles-info-sec aa-suggestion-title">
                                {!file.link && file.title && (
                                    <h2 className="aa-text-xs">{file.title}</h2>
                                )}
                                {file.link && file.title && (
                                    <h2 className="aa-text-xs">
                                        <a className="moreText aa-file-link" role="link">
                                            {file.title}
                                        </a>
                                    </h2>
                                )}
                            </div>
                        </div>
                        <div className="suggestion-body-faq">
                            <p className="aa-desc-xs suggestion-paragraph" dangerouslySetInnerHTML={{ __html: rootServiceInstance.sanitizeHTML(file?.content) }} />
                            
                            <div className="more-links-buttons aa-seemore-buttons aa-hidden">
                                <button className="more-link-text aa-text-xs aa-more-button"  role="link">{languageData?.MORE_TEXT}</button>
                            </div>

                            {file.link && !file.title && (
                                <div className="more-links-buttons">
                                    <button className="more-link-text aa-text-xs aa-file-link" role="link">{languageData?.VIEW_FULL_FILE_2}</button>
                                </div>
                            )}

                        </div>
                    </div>
                ))
            }
        </div>
    );
}
